"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var Container = function Container(_ref) {
  var children = _ref.children;
  return _react.default.createElement("div", {
    className: "container"
  }, children);
};

Container.propTypes = {
  children: _react.PropTypes.node
};
var _default = Container;
exports.default = _default;
module.exports = exports.default;